module.exports = __webpack_public_path__ + "media/images/emblems/Lommis-Blazono-e289ba0b1fa6e904228c6d13a418f294.png";